module.exports = __webpack_public_path__ + "6ac1074c3ad60163d6d52ecfd346e950.ttf"


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/chromecast/public/chromecast.ttf?-2rwb6t
 ** module id = 152
 ** module chunks = 0
 **/